import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.keyframe.fade.in',
		useFor: 'Element appearing (e.g. Tooltip)',
		value: '0-100%',
	},
	{
		tokenName: 'motion.keyframe.fade.out',
		useFor: 'Element disappearing (e.g. dismissed message)',
		value: '100-0%',
	},
];

/**
 * __Fade transitions table__
 */
export const MotionFadeTransitionsTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-fade-table" />;
};
